import {
    AciquirerFeePaymentMethod,
    Acquirer,
    AcquirerFee,
} from "../interfaces/acquirer";

export const findFee = (
    acquirer: Acquirer,
    paymentMethod: AciquirerFeePaymentMethod
): AcquirerFee | undefined => {
    return acquirer?.fees?.find(
        (item) => item?.payment_method === paymentMethod
    );
};
